import React, { useEffect, useState, useMemo } from "react";
import jsPDF from "jspdf";
import { Link } from "react-router-dom";
import axios from "axios";

import DataTable from "react-data-table-component";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";
import CleanupConfirmationModal from "../../../../components/Modal/CleanupConfirmation";
import { checkUserPermission } from "../../../../common/UserPermission";
import * as XLSX from "xlsx";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "";
let PERMISSION_EDIT = "/manage-item-Kits/:id";
let PERMISSION_DELETE = "delete-item-kits";
let PERMISSION_MANAGE_DELETED_ITEMSKIT = "/deleted-items-kits";
let PERMISSION_EXCEL_IMPORT = "/import-excel-items-kits";
let PERMISSION_EXCEL_EXPORT = "excel-export-items-kits";
let PERMISSION_CLEANUP_OLD_ITEMSKIT = "cleanup-old-itemskit";
let PERMISSION_CUSTOM_FIELD_CONFIGURATION = "/items-kit-custom-fields";

let PERMISSION_EMAIL_ITEMSKIT = "email-itemskit";
let PERMISSION_MAILING_LABELS = "mailing-labels-itemskit";
let PERMISSION_DELETE_SELECTED = "delete-selected-itemskit";

const Itemskit = () => {
  let selectData = [];
  let pathforpdf = "";
  let selectDatas = [];
  const token = localStorage.getItem("Token");
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [sortingId, setSortingId] = useState(6);
  const [state, setState] = useState("");
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedItemskitCheckboxs, setselectedItemskitCheckbox] = useState("");
  const [selectedItemskitCheckEmails, setselectedItemskitCheckEmails] =
    useState("");
  const [selectedItemskitCheckpathforpdf, setselectedItemskitCheckpathforpdf] =
    useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder
  ) => {
    setLoading(true);
    axios
      .get(
        `${config.itemKitsBaseUrl}/itemkits/findAll?pagenumber=${pagenumber}&pagesize=${pagesize}&filtertext=${filtertext}&ordercolumn=${ordercolumn}&currentorder=${currentorder}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);

        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // pdf make onclick
  const componentDidMount = () => {
    axios
      .get(
        `${config.itemKitsBaseUrl}/customers/customerdetailforlabel?id=${selectedItemskitCheckboxs}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        this.setState({ data: res.data.ResponseData });
      });
  };
  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      // for get detlais form id
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
      const selectedItemKitsCheckboxIDs =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      const selectedDataDelete =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setSelectedDataDelete(selectedDataDelete);
      setselectedItemskitCheckbox(selectedItemKitsCheckboxIDs);

      const datasplitforpath = selectedItemKitsCheckboxIDs?.split(",");
      pathforpdf = datasplitforpath?.join("~");
      setselectedItemskitCheckpathforpdf(pathforpdf);
      console.log("pathforpdf", pathforpdf);

      // get emails of selectdids
      setSelectedRows(e.selectedRows.map((x) => x.Email));
      selectData[currentPage] = e.selectedRows.map((x) => x.Email);
      const selectedItemKitsCheckboxEmails =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedItemskitCheckEmails(selectedItemKitsCheckboxEmails);
    }
  };

  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      ItemKitId: pID || selectedDataDelete,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
  };

  const contextActions = useMemo(() => {
    const handlepdf = () => {
      axios
        .get(
          `${config.itemKitsBaseUrl}/customers/customerdetailforlabel?id=${selectedItemskitCheckboxs}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const doc = new jsPDF();

          let position = 0;
          for (let i = 0; i < res.data.ResponseData.length; i++) {
            position = position + 10;
            doc.setFontSize(10);
            doc.text(
              `UPC/EAN/ISBN: ${res.data.ResponseData[i].Name}`,
              10,
              position
            );
            position = position + 10;
            doc.text(
              `LastName: ${res.data.ResponseData[i].LastName}`,
              10,
              position
            );
            position = position + 10;
            doc.text(`Email: ${res.data.ResponseData[i].Email}`, 10, position);
            position = position + 10;
            doc.text(`City: ${res.data.ResponseData[i].City}`, 10, position);
            position = position + 10;
            doc.text(
              `Address1: ${res.data.ResponseData[i].Address1}`,
              10,
              position
            );

            position = position + 10;

            if (i % 4 == 0 && i >= 4) {
              console.log("i", i++);
              doc.addPage();
              position = 0;
            }
          }
          //   doc.deletePage(Last);
          doc.save(`${selectedItemskitCheckpathforpdf}.pdf`);
          setState({ data: res.data.ResponseData });
        });
    };
    return (
      <>
        <div className="row px-2 ">
          <div className="col-12 align-self-center">
            {checkUserPermission(PERMISSION_EMAIL_ITEMSKIT) ? (
              <a href={"mailto:" + selectedItemskitCheckEmails}>
                <button type="button" className="btn btn-dark btn-sm ">
                  <i className="fa fa-envelope fa-sm" /> E-mail
                </button>
              </a>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="row px-2">
          <div className="col-12 align-self-center">
            {checkUserPermission(PERMISSION_MAILING_LABELS) ? (
              <button
                type="button"
                className="btn btn-dark btn-sm"
                title="MailingLabels"
                onClick={handlepdf}
              >
                <i className="fa fa-envelope-square fa-sm" /> Mailing-Labels
              </button>
            ) : (
              ""
            )}
          </div>
        </div>

        <div className="row px-2">
          <div className="col-12 align-self-center">
            {checkUserPermission(PERMISSION_DELETE_SELECTED) ? (
              <button
                type="button"
                className="btn btn-danger btn-sm pull-left "
                data-bs-toggle="modal"
                data-bs-target="#DeleteConfirmationModal"
                onClick={() => handleDeletePopup()}
              >
                <i className="fas fa-trash fa-sm" /> Delete Selected
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </>
    );
  }, [data, selectedRows, toggleCleared]);

  useEffect(() => {
    handleListData(1, perPageSize, searchtext, sortingId, sortingDirection);
  }, []);

  // Table Data
  const columns = [
    {
      name: "ID",
      selector: "ID",
      width: "5%",
      sortable: true,
    },
    {
      name: "UPC/EAN/ISBN",
      selector: "ProductId",
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.Name,
      sortable: true,
    },
    {
      name: "Category",
      selector: "Category",
      sortable: true,
    },

    {
      name: "Cost Price",
      // width: "5%",
      selector: "Costprice",
      sortable: true,
      cell: (row) =>
        row.Costprice ? `${Number(row.Costprice).toFixed(2)}` : "",
    },
    {
      name: "Selling Price",
      // width: "5%",
      selector: "Unitprice",
      sortable: true,
      cell: (row) =>
        row.Unitprice ? `${Number(row.Unitprice).toFixed(2)}` : "",
    },

    {
      name: "Images",
      selector: "Images",
      sortable: true,
      cell: (row) => (
        <>
          <img
            src={row.Images}
            alt="Selected Image"
            style={{
              maxWidth: "100px",
              maxHeight: "100px",
              margin: "5px",
            }}
          />
        </>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <>
          {checkUserPermission(PERMISSION_EDIT) ? (
            <Link className="me-3" to={`/manage-item-Kits/${row.ID}`}>
              <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
            </Link>
          ) : (
            ""
          )}
          {checkUserPermission(PERMISSION_DELETE) ? (
            <Link
              className="confirm-text"
              to="#"
              title="Delete"
              data-bs-toggle="modal"
              data-bs-target="#DeleteConfirmationModal"
              onClick={() => handleDeletePopup(row.ID)}
            >
              <i
                className="fa fa-trash text-red fa-2x"
                data-bs-toggle="tooltip"
                title="Delete"
              ></i>
            </Link>
          ) : (
            ""
          )}
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  //export excel of data
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.itemKitsBaseUrl}/itemkits/exportexcel`,
        {
          filtertext: searchtext,
          ordercolumn: sortingId,
          currentorder: sortingDirection,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);

        const data =
          res.data.ResponseData.length > 0 ? res.data.ResponseData : [];

        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Convert the data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, `itemkits_details_.xlsx`);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  function handleCheckboxChange(columnName) {
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  }

  // generate new columns according to hiddenColumns data and pass it as datatable column
  const filteredColumns = columns.filter(
    (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  );

  return (
    <>

      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Item Kits</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Item Kits List</li>
                </ul>
              </div>
            </div>
            <div>
              {/* dynamically hide or show columns */}
              <div className="btn-group pull-right ms-2 dropdown">
                <button
                  type="button"
                  className="btn btn-outline-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="fa fa-cog"></i> &nbsp;
                </button>
                <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } // check all checkboxes which are not include in hiddenColumns
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </div>
              <div className="btn-group  pull-right ms-2">
                <button type="button" className="btn btn-action d-none">
                  Action
                </button>
                <button
                  type="button"
                  className="btn btn-outline-dark dropdown-toggle me-1"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  More &nbsp;
                  {/* <span className="sr-only">Toggle Dropdown</span> */}
                </button>
                <div className="dropdown-menu">
                  <li>
                    {checkUserPermission(PERMISSION_EXCEL_IMPORT) ? (
                      <Link class="dropdown-item" to="/import-excel-customers">
                        Excel Import
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_EXCEL_EXPORT) ? (
                      <Link class="dropdown-item" onClick={handleExcelExport}>
                        Excel Export
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_MANAGE_DELETED_ITEMSKIT) ? (
                      <Link class="dropdown-item" to="/deleted-items-Kits">
                        Manage Deleted Items Kit
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_CLEANUP_OLD_ITEMSKIT) ? (
                      <Link
                        to="#"
                        title="Cleanup old Customers"
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#CleanupConfirmationModal"
                      >
                        Cleanup old Items
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(
                      PERMISSION_CUSTOM_FIELD_CONFIGURATION
                    ) ? (
                      <Link class="dropdown-item" to="/items-kit-custom-fields">
                        Items Kit Custom Fields
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                </div>
              </div>
              {checkUserPermission(PERMISSION_EDIT) ? (
                <Link
                  to="/manage-item-Kits"
                  className="btn btn-added pull-right"
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  New Item Kits
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>

          <br />
          <br />

          <div className="row flex-row-reverse mt-2 mb-2">
            <div className="col-2 float-end">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control"
                onChange={ChangeFilterText}
                value={searchtext}
              />
            </div>
          </div>

          {/* Items list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  title="Item Kits List"
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  sortServer
                  onSort={handleSort}
                  selectableRows
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.itemKitsBaseUrl}/itemkits/deletemultiple`}
      />

      {/* Cleanup old items */}
      <CleanupConfirmationModal
        CleanupConformationApiUrl={`${config.itemKitsBaseUrl}/itemkits/deletepermanantely`}
      />
    </>
  );
};

export default Itemskit;
